import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Campo de palavra-passe com alternador de visibilidade.
 *
 * O botão fica FORA da ordem de tabulação (`tabIndex={-1}`): quem preenche o
 * formulário pelo teclado quer saltar da palavra-passe direto para Entrar, e
 * não apanhar um botão de olho pelo caminho.
 *
 * `aria-pressed` e o `aria-label` a mudar de texto dizem a um leitor de ecrã
 * qual é o estado atual — um ícone sozinho não diz nada.
 */
export function CampoSenha({
  className,
  ...props
}: React.ComponentProps<typeof Input>) {
  const [visivel, setVisivel] = useState(false);

  return (
    <div className="relative">
      <Input
        {...props}
        type={visivel ? "text" : "password"}
        className={cn("pr-10", className)}
      />
      <button
        type="button"
        tabIndex={-1}
        aria-pressed={visivel}
        aria-label={visivel ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
        title={visivel ? "Ocultar palavra-passe" : "Mostrar palavra-passe"}
        onClick={() => setVisivel((v) => !v)}
        className="text-muted-foreground hover:text-foreground focus-visible:ring-ring absolute top-1/2 right-1 flex size-8 -translate-y-1/2 items-center justify-center rounded-md transition-colors focus-visible:ring-2 focus-visible:outline-none"
      >
        {visivel ? <EyeOff className="size-4" /> : <Eye className="size-4" />}
      </button>
    </div>
  );
}
